<!-- @format -->

<div ngbDropdown #dropdown="ngbDropdown">
  <button
    type="button"
    ngbDropdownToggle
    class="form-control form-control-inverted"
    [attr.aria-label]="selectedPlan?.name + '. ' + ('ARIA_LABEL.SELECT_PLAN_NOW_SELECTED' | translate)">
    {{ selectedPlan?.name }}
    <sis-icon icon="chevron" iconClass="cw-90" color="white"></sis-icon>
  </button>
  <div ngbDropdownMenu class="multiple-line-items" role="menu">
    @for (option of options; track option) {
      @if (option.education) {
        <span class="dropdown-header" role="heading">
          {{ option.education.name | localizedString }}
        </span>
      }
      @if (!option.education && option.plan) {
        <button
          ngbDropdownItem
          role="option"
          (click)="onSelect(option.id); dropdown.close()"
          [attr.aria-current]="option.id === selectedPlan?.id"
          [class.active]="option.id === selectedPlan?.id">
          {{ option.plan.name }}
          @if (option.id === selectedPlan?.id) {
            <span class="visually-hidden">{{ "ARIA_LABEL.SELECTED" | translate }}</span>
          }
          @if (option.plan.primary) {
            <span class="tiny-badge success" data-cy="study-plan-primary-badge">
              {{ "PRIMARY_STUDY_PLAN" | translate }}
            </span>
          }
          <span class="additional-data">
            {{ "STUDY_PLAN_MODIFIED" | translate: { modified: option.plan.metadata.lastModifiedOn | localDateFormat } }}
          </span>
        </button>
      }
    }
  </div>
</div>
